<template>
  <div class="scoreAndComment">
    <!-- <div class="score">
      <div class="overall">
        <p class="p1">{{rating}}</p>
        <p class="p2">综合评分</p>
      </div>
      <div class="rank">
        <div class="star">
          <img class="rankStar" src="~assets/images/game/rankStar.png" alt="">
          <div class="progress" v-if="ratingData.length>0">
            <div class="outer" v-for="(item,index) in ratingData" :key="index">
              <div class="inner" :style="'width:'+ item +'%;'"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="comment">
      <Rate v-model="scoreNum"></Rate>
      <span class="clickScore">为这款游戏打个分吧</span>
      <div class="goComment">
        <span>我要评论</span>
        <img src="~assets/images/game/comment.png" alt="">
      </div>
    </div> -->
  </div>
</template>
<script>
import { Rate } from 'iview'
import { mapState,mapMutations } from 'vuex'
export default {
  props:['gameId'],
  data(){
    return {
      scoreNum:3,
      avg:'',
      ratingData:[],
    }
  },
  components: {
    Rate
  },
  computed:{
    ...mapState({
      rating:state => state.game.rating,
    })
  },
  created(){ 
    if(!this.rating){
      // test1700.233xyx.com/apiserv/bbs/ratingV1/frontend/getGameScore?gameId=${this.gameId}
      this.$http.post(`/apiserv/bbs/ratingV1/frontend/getGameScore?gameId=${this.gameId}`).then(res => {
        if(res.data.return_code == 200){
          this.avg = res.data.data.avg.toFixed(1)
          this.ratingData = res.data.data.ratingData.reverse()  
          this['game/setScore'](this.avg)    
        }     
      })
    }
  },
  methods:{
    ...mapMutations([
      'game/setScore'
    ])
  }
}
</script>
<style lang="less" scoped>
.scoreAndComment{
  margin-top: 0.08rem;
  padding: 0.21rem 0.17rem;
  background: #fff;
  .score{
    height: 0.97rem;
    padding-bottom: 0.2rem;
    border-bottom: 1px solid #E6E6E6;
    .overall{
      float: left;
      width: 0.68rem;
      height: 0.62rem;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      background:linear-gradient(360deg,rgba(255,149,0,1) 0%,rgba(255,80,0,1) 100%);
      border-radius:0.04rem;
      text-align: center;
      color: #fff;
      .p1{
        line-height: 0.33rem;
        font-size:0.33rem;
        font-weight:bold;
      }
      .p2{
        line-height: 0.17rem;
        font-size:0.13rem;
        font-weight: 400;
      }
    }
    .rank{
      float: left;
      .star{
        margin-left: 0.13rem;
        >img{
          margin-right: 0.08rem;
          width: 0.6rem;
          height: 0.6rem;
          float: left;
        }
        .progress{
          float: left;
          width: 1.9rem;
          margin-top: 0.04rem;
          .outer{
            width: 1.9rem;
            height: 0.03rem;
            background: #F1F1F1;
            margin-bottom: 0.095rem;
            .inner{
              height: 0.03rem;
              background: #808080;
            }
          }
        }
      }

    }
  }
  .comment{
    height: 1.63rem;
    padding: 0.21rem 0.68rem;
    text-align: center;
    font-size:0.15rem;   
    .ivu-rate{
      font-size: 0.33rem !important;
      margin: 0 auto;
    }
    .ivu-rate-star{
      margin-right: 0.08rem !important;
    }
    .clickScore{
      color: #999;
      margin-bottom: 0.17rem;
      display: inline-block;
    }
    .goComment{
      width:1.15rem;
      height:0.38rem;
      border-radius:0.21rem;
      border: 1px solid #ccc;
      color: #333;
      padding: 0.08rem 0.17rem;
      margin: 0 auto;
      display: flex;
      align-items: center;
      img{
        width: 0.17rem;
      }
    }
  }
}
</style>